"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PrimarySelect = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _reactSelect = _interopRequireWildcard(require("react-select"));

var _creatable = _interopRequireDefault(require("react-select/creatable"));

var _propTypes = require("prop-types");

var _menu = require("./menu");

var _dropdownIndicator = require("./dropdown-indicator");

var _valueContainer = require("./value-container");

var _control = require("./control");

var _styles = require("./control/styles");

var _styles2 = require("./styles");

var _classnames = _interopRequireDefault(require("classnames"));

var _loadStyles = _interopRequireDefault(require("load-styles"));

var _useStyles = require("../../../helpers/useStyles");

var _excluded = ["theme", "styles", "components", "view", "bg", "showBorder", "className", "isCreatable", "isCheckable", "value", "options"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

(0, _loadStyles.default)(".c1e60c8d5+:not(.c1e60c8d5){position:relative;padding-top:8px;margin-top:8px}.c1e60c8d5+:not(.c1e60c8d5):before{position:absolute;left:8px;right:8px;height:1px;background-color:#dbdde2;top:0;content:'';border-radius:2px}.ce42df59c{display:flex;align-items:center;grid-gap:12px;grid-gap:12px;gap:12px;color:var(--color-flomni-gray-90)}.ce42df59c input{margin:0;width:16px;min-width:16px;height:16px;accent-color:var(--color-flomni-blue-70);border-radius:2px}.ce42df59c label{word-break:break-all}");
var css = {
  checked: 'c1e60c8d5',
  item: 'ce42df59c'
};

var PrimarySelect = function PrimarySelect(props) {
  var themeProp = props.theme,
      stylesProp = props.styles,
      components = props.components,
      view = props.view,
      bg = props.bg,
      showBorder = props.showBorder,
      className = props.className,
      isCreatable = props.isCreatable,
      isCheckable = props.isCheckable,
      value = props.value,
      options = props.options,
      rest = (0, _objectWithoutProperties2.default)(props, _excluded);
  var cn = (0, _useStyles.useStyles)(css, {});
  var theme = (0, _react.useMemo)(function () {
    return (0, _styles2.getTheme)(view, bg);
  }, [bg, view]);
  var controlStyles = {
    control: (0, _styles.getControlStyles)(props)
  };
  var ASelectComponent = isCreatable ? _creatable.default : _reactSelect.default;

  var Option = function Option(props) {
    return isCheckable ? /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(props.isSelected ? cn.checked : '')
    }, /*#__PURE__*/_react.default.createElement(_reactSelect.components.Option, props, /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(cn.item)
    }, /*#__PURE__*/_react.default.createElement("input", {
      type: "checkbox",
      checked: props.isSelected,
      onChange: function onChange() {
        return null;
      }
    }), /*#__PURE__*/_react.default.createElement("label", null, props.label)))) : /*#__PURE__*/_react.default.createElement(_reactSelect.components.Option, props);
  };

  var currentOptions = isCheckable ? options.sort(function (a, b) {
    var aFind = value === null || value === void 0 ? void 0 : value.find(function (item) {
      return item.value === a.value;
    });
    var bFind = value === null || value === void 0 ? void 0 : value.find(function (item) {
      return item.value === b.value;
    });

    if (!aFind) {
      return !bFind && a.label < b.label ? -1 : 1;
    }

    if (aFind) {
      return bFind && a.label > b.label ? 1 : -1;
    }

    return 0;
  }) : options;
  return /*#__PURE__*/_react.default.createElement(ASelectComponent, (0, _extends2.default)({
    styles: _objectSpread(_objectSpread(_objectSpread({}, _styles2.styles), stylesProp), controlStyles),
    theme: themeProp || theme,
    components: _objectSpread({
      ValueContainer: _valueContainer.ValueContainer,
      DropdownIndicator: _dropdownIndicator.DropdownIndicator,
      Menu: _menu.Menu,
      Control: _control.Control,
      Option: Option
    }, components),
    view: view,
    bg: bg,
    className: className,
    classNamePrefix: className,
    value: value,
    options: currentOptions
  }, rest));
};

exports.PrimarySelect = PrimarySelect;
var view = ['usual', 'tall'];
var bg = ['white', 'transparent'];
var menuPlacement = ['auto', 'bottom', 'top'];
PrimarySelect.modes = {
  view: view,
  bg: bg,
  menuPlacement: menuPlacement
};
PrimarySelect.propTypes = {
  /* component logic props */
  theme: _propTypes.func,
  styles: _propTypes.object,
  components: _propTypes.object,

  /* styling modificators */
  view: (0, _propTypes.oneOf)(view),
  bg: (0, _propTypes.oneOf)(bg),
  menuPlacement: (0, _propTypes.oneOf)(menuPlacement),
  isCreatable: _propTypes.bool,
  isCheckable: _propTypes.bool,
  showBorder: _propTypes.bool,
  className: _propTypes.string
  /* classes */

};
PrimarySelect.defaultProps = {
  theme: null,
  styles: {},
  components: {},
  view: 'usual',
  bg: 'white',
  menuPlacement: 'auto',
  showBorder: false,
  className: '',
  isCreatable: false,
  isCheckable: false
};